import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from './shared/shared.module';
import {Store} from '@ngrx/store';
import {distinctUntilChanged, filter, map, Subscription, take} from 'rxjs';
import {selectTheme} from './store/layout/layout.selectors';
import {setDarkMode, setTitle} from './store/layout/layout.action';
import {Title} from "@angular/platform-browser";
import {ConfirmationService, MessageService} from "primeng/api";
import {SharedPrimeNgModule} from "./prime-ng/prime-ng.module";
import {SharedUtils} from "./shared/services/utils/shared-utils.service";
import {TranslocoService} from "@jsverse/transloco";
import {ScrollTopModule} from "primeng/scrolltop";
import {ChangeLangService} from "./core/services/change-lang.service";
import {CurrentUserService} from "./shared/services/current-user.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    SharedPrimeNgModule,
    ScrollTopModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'ams-dashboard';
  private subs = new Subscription();
  selectedTheme: string = '';

  constructor(private store: Store, private changeLangService: ChangeLangService,  private titleService: Title, private router: Router, private activatedRoute: ActivatedRoute, private messageService: MessageService, public confirmationService: ConfirmationService, private translateService: TranslocoService, private currentUserService: CurrentUserService) {
    this.changeLangService.changeLang('it');//meglio da configurazione
    SharedUtils.setInstance(messageService, confirmationService, translateService, currentUserService);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.subs.add(this.store.select(selectTheme).pipe(distinctUntilChanged(), take(1)).subscribe(theme => this.store.dispatch(setDarkMode(theme))));


    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          return child?.snapshot.data['title'] || 'AMS';
        })
      )
      .subscribe(title => this.store.dispatch(setTitle(title)));
  }

  protected readonly window = window;
  protected readonly alert = alert;
}
